import React, { Component } from 'react';

export class InfoDialog extends Component {
  resolve;

  state = { 
    display: "dnone",
  }

  close =()=> {
    this.setState({ display: "dnone" });
  }

  show = async (text, btn1, btn2) => {
    this.setState({
        text, btn1, btn2,
        display: "dblock"
    })
    return new Promise(rs => this.resolve = rs)
  }

  cancel =e=> {
    if(e.target.id == "infoDialog" || e.target.id == "zrusit" || e.target.className == "close") {
      this.close();
      this.resolve(false);
    }
  }

  no =()=> {
    this.setState({ display: "dnone"});
    this.resolve(false);
  }

  yes =()=> {
    this.setState({ display: "dnone"});
    this.resolve(true);
  }

  render() {
    const s = this.state;

    return (
      <div className={"modal " + s.display} id="infoDialog" onClick={this.cancel}>
        <div className="modal-dialog modal-sm">
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="close" data-dismiss="modal">×</button>
              <h4 className="modal-title">Info</h4>
            </div>
            <div className="modal-body">
                {this.state.text}
            </div>
            <div className="modal-footer">
              {this.state.btn1 == "Yes" ? 
                <button className="btn btn-success" id="ano" onClick={this.yes}>Ano</button> :
                <button className="btn btn-warning" id="zpet" onClick={this.no}>Zpět</button>
              }
              {this.state.btn2 == "No" ? 
                <button className="btn btn-danger" id="no" onClick={this.no}>Ne</button> : []
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}